<template>
  <section :style="{ 'background-color': $theme.grey }">
    <div class="row LP-header">
      <div class="col">
        <div class="container">
          <h1 style="font-weight: normal;cursor: pointer" class="display-4" @click="routeToMain()">
            <i class="fa fa-user" aria-hidden="true"></i>
            <!-- TODO: Tie to Loan TypeID -->
            Mortgage Loan
            <small class="text-muted"
              >/ Officer
              <i class="fa fa-lock text-success success" aria-hidden="true"></i>
            </small>
          </h1>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="margin-top: 40px">
        <div class="col">
          <template>
            <div
              style="display: flex;justify-content: space-between;flex-wrap: wrap;"
            >
              <div>
                <h5>
                  Select a Loan Officer
                </h5>
                <p>
                  <b
                    >Select a loan officer from the the list below{{
                      this.settings &&
                      this.settings.requireOfficerSelect &&
                      this.settings.requireOfficerSelect.value
                        ? "."
                        : " or click next to have an officer assigned to you."
                    }}
                  </b>
                </p>
              </div>

              <div style="margin-bottom: 4rem" v-if="allSet">
                <base-button
                  type="primary"
                  style="margin-top: 20px;"
                  @click="save"
                  >Next</base-button
                >
              </div>
            </div>

            <div class="officers" style="overflow: scroll;max-height: 350px;">
              <div
                class="officer"
                v-for="officer of officers"
                :key="officer.UserGUID"
                @click="selectOfficer(officer)"
              >
                <div
                  v-if="officer.profile"
                  class="avatar"
                  :style="{
                    'background-image': 'url(' + officer.profile.Image + ')',
                  }"
                ></div>
                <div class="info" v-if="officer.profile">
                  <div class="name">
                    {{
                      officer.profile.Name !== " "
                        ? officer.profile.Name
                        : officer.profile.EmailAddress
                    }}
                  </div>
                  <div class="phone">
                    {{ officer.profile.Phone | phoneNumber }}
                  </div>
                </div>
                <div
                  v-if="selectedOfficer === officer.UserGUID"
                  class="selected"
                  :style="{ 'background-color': iconBG }"
                >
                  <i
                    class="fa fa-check"
                    aria-hidden="true"
                    :style="{ color: icon }"
                  ></i>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from "../components/BaseButton.vue";
import { getAccountOfficers, assignOfficer } from "../services/officers";
import { success, warning } from "../services/message";
import { getApplication } from "../services/application";
import { getAccountSettings } from "../services/settings";
export default {
  components: { BaseButton },
  name: "officers",
  filters: {
    phoneNumber(value) {
      if (!value) return "";
      let cleaned = ("" + value).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      }
      return null;
    },
  },
  data() {
    return {
      id: null,
      officers: null,
      loading: false,
      selectedOfficer: null,
      co: null,
      disableSubmit: false,
      iconBG: this.$theme.successLight,
      icon: this.$theme.success,
      allSet: false,
      settings: null,
      app: null,
    };
  },
  async created() {
    window.addEventListener("theme", () => {
      (this.iconBG = this.$theme.successLight),
        (this.icon = this.$theme.success);
    });
    let res;
    if (this.$route.params.id !== "new") {
      this.id = this.$route.params.id;
      res = await getApplication(this.id);
      this.app = res.LoanAppJSON;
      this.co = res.coBorrower;
      if (res.status === 200 && !res.coBorrower) {
        this.getOfficers();
      } else if (res.status === 200 && res.coBorrower) {
        this.$router.push(`/application/${this.$route.params.id}/fields`);
      } else {
        this.$router.push("/");
        warning(res.message);
      }
    } else {
      this.$router.push("/");
      warning(res.message);
    }
    let results = await getAccountSettings();
    this.settings = results.data;
    if (
      this.settings &&
      this.settings.requireOfficerSelect &&
      this.settings.requireOfficerSelect.value
    ) {
      this.allSet = false;
    } else {
      this.allSet = true;
    }
  },
  methods: {
    async getOfficers() {
      this.officers = await getAccountOfficers();
    },
    selectOfficer(officer) {
      if (this.selectedOfficer === officer.UserGUID) {
        this.selectedOfficer = null;
        if (this.settings.requireOfficerSelect.value) {
          this.allSet = false;
        }
      } else {
        this.selectedOfficer = officer.UserGUID;
        if (this.settings.requireOfficerSelect.value) {
          this.allSet = true;
        }
      }
    },
    async routeToMain() {
      if (this.allSet) {
        this.$router.push({
            name: "main-application",
            params: { id: this.$route.params.id },
          });
      } else {
        warning("Please select a Loan Officer");
      }

    },
    async save() {
      if (this.selectedOfficer) {
        if (!this.disableSubmit) {
          try {
            this.disableSubmit = true;
            await assignOfficer(this.$route.params.id, this.selectedOfficer);
            success("Officer Assigned");
          } catch (error) {
            warning("Error Assigning Officer");
            this.disableSubmit = false;
          }
        }
      }

      if (this.co) {
        this.$router.push({
          name: "fields",
          params: { id: this.$route.params.id },
        });
      } else {
        if (
          this.app.progress.sections.coBorrower &&
          this.app.progress.sections.coBorrower.progress == 100
        ) {
          this.$router.push({
            name: "main-application",
            params: { id: this.$route.params.id },
          });
        } else {
          this.$router.push({
            name: "co-borrower",
            params: { id: this.$route.params.id },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.officers {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .officer {
    display: flex;
    align-items: center;
    padding: 1rem;
    background: white;
    border-radius: 4px;
    margin: 1rem 1rem 1rem 0;
    flex: 1;
    flex-basis: 300px;
    cursor: pointer;
    .avatar {
      width: 80px;
      height: 80px;
      background-size: cover;
      background-repeat: no-repeat;
      background-color: white;
      box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1),
        0 5px 15px rgba(0, 0, 0, 0.07) !important;
    }
    .info {
      padding: 1rem;
      flex: 1;
    }
    .selected {
      background: #2dce8945;
      padding: 0.5rem;
      border-radius: 50%;
      width: 48px;
      i {
        font-size: 30px;
        color: #2dce89;
      }
    }
  }
}
</style>
